import type { MavisLiveEvent, MavisMeetingSession } from '../../types/mavis';
export function utteranceKey(row: MavisLiveEvent): string {
  // The provider includes bot + transcript artifact + participant + start time.
  return row.provider_event_id?.replace(/:transcript_(partial|segment|final):/, ':utterance:') ?? row.id;
}
export function transcriptRows(finals: MavisLiveEvent[], partials: MavisLiveEvent[]): MavisLiveEvent[] {
  const rows=new Map<string,MavisLiveEvent>();
  for (const row of partials) { const key=utteranceKey(row); const previous=rows.get(key); if (!previous || (row.event_timestamp ?? '')>(previous.event_timestamp ?? '')) rows.set(key,row); }
  for (const row of finals) rows.set(utteranceKey(row),row);
  return [...rows.values()].filter(row=>row.content_text?.trim()).sort((a,b)=>{
    const botA=a.provider_event_id?.split(':')[2],botB=b.provider_event_id?.split(':')[2];
    if (botA===botB) return Number(a.content_json?.relative_start ?? 0)-Number(b.content_json?.relative_start ?? 0) || a.created_at.localeCompare(b.created_at);
    return a.created_at.localeCompare(b.created_at);
  });
}
export function meetingStatus(session: MavisMeetingSession): string {
  const meta=session.recall_bot_metadata ?? {};
  if (['completed','ended'].includes(session.status)) return 'Call ended';
  if (session.status==='left') return 'Left meeting';
  if (session.status==='failed') return 'Could not join';
  if (meta.leave_requested) return 'Leaving meeting';
  if (meta.capture_paused) return 'Paused';
  if (meta.status_code==='in_waiting_room') return 'In waiting room';
  if (['joined','active','recording'].includes(session.status)) return 'In meeting';
  if (session.status==='joining') return 'Joining meeting';
  return 'Not joined';
}
